import { get, post, postForm, putForm } from "api";
import dayjs from "dayjs";
import { useRecoilValue } from "recoil";
import { authState } from "recoil/auth";
import Api from "../../api";

const useApiActions = () => {
  const auth = useRecoilValue(authState);

  return {
    postFormWithToken,
    putFormWithToken,
    postWithToken,
    getWithToken,
    delWithToken,
    putWithToken,
    setLog,
  };

  async function postFormWithToken(url, params) {
    if (!auth.token) {
      alert("no token");
      return;
    }

    const res = await postForm(url, params, {
      accesstoken: auth.token.accesstoken,
    });
    return res;
  }

  async function putFormWithToken(url, params) {
    if (!auth.token) {
      alert("no token");
      return;
    }

    const res = await putForm(url, params, {
      accesstoken: auth.token.accesstoken,
    });
    return res;
  }

  async function postWithToken(url, params) {
    if (!auth.token) {
      alert("no token");
      return;
    }

    const res = await Api.post(url, params, {
      accesstoken: auth.token.accesstoken,
    });
    return res;
  }

  async function getWithToken(url, params) {
    console.log(auth.token)
    if (!auth.token) {
      alert("no token");
      return;
    }

    const res = await Api.get(url, {
      params,
      accesstoken: auth.token.accesstoken,
    }).catch((err) => {
      console.log(err);
      return err.response;
    });

    return res;
  }

  async function delWithToken(url, params) {
    if (!auth.token) {
      alert("no token");
      return;
    }

    const res = await Api.delete(url, {
      data: params,
      accesstoken: auth.token.accesstoken,
    });
    return res;
  }

  async function putWithToken(url, params) {
    if (!auth.token) {
      alert("no token");
      return;
    }

    const res = await Api.put(url, params, {
      accesstoken: auth.token.accesstoken,
    });
    return res;
  }

  async function setLog({ url = "apply/log", params }) {
    console.log(params);
    return postWithToken(url, {
      os: window.navigator.userAgent,
      text: params.text || "",
      action: params.action || 1,
    });
  }
};

export default useApiActions;
